import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "t2-main" }
const _hoisted_2 = { class: "t2-content" }
const _hoisted_3 = { class: "container mar_b" }
const _hoisted_4 = { class: "t6_pager" }

import Banner from "@/views/online-report/banner/index1.vue";
import {reactive, ref, toRaw} from "vue";
import {getPublicNoticeList} from '@/config/request'
import { useRouter } from 'vue-router';
import {IMG_PREVIEW, IMAGE_PREVIEW} from "@/config/const";
import {ElMessage} from "element-plus";

export default /*@__PURE__*/_defineComponent({
  __name: 'creditPublicity',
  setup(__props) {

const router = useRouter()
const pagination = reactive({
    pageNo: 1,
    pageSize: 10
})
const pubList = ref<any>([]);
const handleCurrentChange = (index:any) => {
    pagination.pageNo = index
    init();
}
const init = async () => {
    await getPublicNoticeList(pagination).then((res: any) => {
        if(res.code == 200){
            pubList.value = res.result.records;
            pagination.total = res.result.total;
        }
    })
}
const subgo = (row:any) => {
    let obj = JSON.stringify(toRaw(row))
    router.push({
        path: '/projectInfo',
        state: { obj }
    })
}

const preview = (row:any) => {
    if(row.includes(',')){
        let obj = toRaw(row).split(',')
        obj.forEach((item:String) => {
            item = item.trim();
            if(item.includes('[')){
                item = item.replace('[', '');
            }else if(item.includes("]")) {
                item = item.replace(']', '');
            }
            console.log(IMAGE_PREVIEW + item)
            window.open(IMAGE_PREVIEW + item, '_blank');
            return IMAGE_PREVIEW + item;
        })
    }else {
        ElMessage.error("暂无数据！")
    }
}
const show = (row:any) => {
    let obj = toRaw(row).split(',')
    if (obj == '' || obj == null || obj.length == 0){
        ElMessage.error("暂无数据！")
    }else{
        obj.forEach((item:String) => {
            if (item!==""){
                item = item.trim();
                if(item.includes('[')){
                    item = item.replace('[', '');
                }else if(item.includes("]")) {
                    item = item.replace(']', '');
                }
                location.href = IMG_PREVIEW + item;
            }
        })
    }
}
init()

return (_ctx: any,_cache: any) => {
  const _component_Top = _resolveComponent("Top")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_Bottom = _resolveComponent("Bottom")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Top),
    _createVNode(Banner),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "t6_breadCream" }, [
            _createElementVNode("span", null, "首页"),
            _createTextVNode(),
            _createElementVNode("i", null, ">"),
            _createTextVNode(),
            _createElementVNode("span", null, "企业信用承诺公示")
          ], -1)),
          _createElementVNode("div", null, [
            _createVNode(_component_el_table, {
              data: pubList.value,
              border: "",
              style: {"width":"100%"},
              "highlight-current-row": "",
              "header-cell-style": {color:'#2185f2',textAlign:'center',borderColor:' #CCC',background:'#ebf6fc',height:'60px'}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "index",
                  label: "序号",
                  width: "80",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "projectname",
                  label: "项目名称",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "incJgmc",
                  label: "申请单位名称",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  label: "项目基本信息",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: ($event: any) => (subgo(scope.row))
                    }, {
                      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createTextVNode("查看", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "承诺书",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: ($event: any) => (preview(scope.row.files))
                    }, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createTextVNode("预览", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: ($event: any) => (show(scope.row.files))
                    }, {
                      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                        _createTextVNode("承诺书", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_pagination, {
                background: "",
                onCurrentChange: handleCurrentChange,
                layout: "prev, pager, next, total",
                "page-size": pagination.pageSize,
                total: pubList.value.length
              }, null, 8, ["page-size", "total"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Bottom)
  ], 64))
}
}

})